import { NgModule } from '@angular/core'
import { ExtraOptions, RouterModule } from '@angular/router'

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'disabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0],
    onSameUrlNavigation: 'reload',
    initialNavigation: 'enabledBlocking'
}

@NgModule({
  imports: [
    RouterModule.forRoot([], routerOptions)
  ]
})
export class AppRoutingModule {
}
